import { lazyLoad } from '../../utils/loadable';
import { fullscreenLoader } from '../Loader/Page/PageLoader';

const appLoader = lazyLoad(() => import('./App'), fullscreenLoader);
export default appLoader;
